import { render } from "./SurveyCreator.vue?vue&type=template&id=ca76e280&scoped=true"
import script from "./SurveyCreator.vue?vue&type=script&lang=js"
export * from "./SurveyCreator.vue?vue&type=script&lang=js"

import "./SurveyCreator.vue?vue&type=style&index=0&id=ca76e280&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca76e280"]])

export default __exports__